import {GET_STATES_REQ, GET_STATES_REQ_FAIL} from "./statesTypes";
import axios from "axios";

export const statesAction = (statesData) => {

    return {
        type: GET_STATES_REQ,
        payload: statesData
    }

}
export const statesActionFail = (error) => {
    return {
        type: GET_STATES_REQ_FAIL,
        payload: error
    }
}


export const getStates = (countryCode, locale) => {
    return (dispatch) => {
        const stateServiceUrl = process.env["state_url "];
        axios.get(process.env.REACT_APP_CUT_REG_BASE_URL + `/state/${countryCode}/${locale}`)
            .then(response => {
                dispatch(statesAction(response.data))
            }).catch(error => {
            dispatch(statesActionFail(error.data))
        })

    }
}
